module.exports = __webpack_public_path__ + "img/hd1.2085fb0d.png";